export const USER_ROLE = {
  CANDIDATE: 3,
  EMPLOYER: 4,
  RECRUITER: 5,
  ASSISTANT: 6,
  ADMIN_ASSISTANT: 7,
  ADMINISTRATOR: 9,
  DIRECTOR: 10,
  FOUNDER: 11,
};

export const USER_AUTHORITY_LEVEL = {
  USER: 2,
  ADMIN: 9,
  SUPER_ADMIN: 10,
};
